import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HighlightPipe } from './shared/pipe/highlight.pipe';
import { LoadingSpinnerComponent } from "./shared/components/loading-spinner/loading-spinner.component";
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';
import { NgxPageScrollCoreModule, PageScrollService } from 'ngx-page-scroll-core';
import { BasicDialogComponent } from './shared/dialog/dialog.component';
@NgModule({
    declarations: [
    LoadingSpinnerComponent,
    HighlightPipe,
    ClickOutsideDirective,
    BasicDialogComponent,
    ],
    imports: [
        CommonModule,
        NgxPageScrollCoreModule.forRoot({ duration: 400, scrollOffset: 80 }),
    ],
    exports: [
    LoadingSpinnerComponent,
    HighlightPipe,
    ClickOutsideDirective,
    NgxPageScrollCoreModule,
    BasicDialogComponent,
    ],
    providers: [PageScrollService]
})
export class SharedModule { }